import script from "./HistoricalEstimateFormScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricalEstimateFormScreen.vue?vue&type=script&setup=true&lang=js"

import "./HistoricalEstimateFormScreen.vue?vue&type=style&index=0&id=723a1131&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-723a1131"]])

export default __exports__